var _G, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Circle, Path } from "react-native-svg";
function SvgTwitterDark(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    transform: "scale(14.28571)"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 17.5,
    cy: 17.5,
    r: 17.06,
    fill: "#1D1C39",
    className: "twitterDark_svg__cls-3"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#E1087E",
    d: "M17.5.88c9.17 0 16.62 7.46 16.62 16.62S26.66 34.12 17.5 34.12.88 26.67.88 17.5 8.33.88 17.5.88m0-.88C7.88 0 0 7.88 0 17.5S7.88 35 17.5 35 35 27.12 35 17.5 27.12 0 17.5 0z",
    className: "twitterDark_svg__cls-2"
  }))), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M121.871 129.582l100.515 132.715-101.143 107.9h22.8l88.286-94.572 71.5 94.572h77.1l-105.7-140.1 93.685-100.515h-22.8l-81.243 86.972-65.914-86.972h-77.086zm33.572 16.615h35.228l157.1 207.385H312.33L155.443 146.197z",
    className: "twitterDark_svg__cls-1"
  })));
}
export default SvgTwitterDark;